export default __webpack_public_path__ + "assets/images/f0f9dab01e636a09c1141711fd619b58.png";